import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { HeadingTags, defaultHeadingTag } from '@primer/react-brand';
import { Box as Container } from '@primer/react';
import { ColorThemePicker } from '../../src/components/content/ColorThemePicker';
import { ColorScales } from '../../src/components';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Themes`}</h2>
    <ColorThemePicker mdxType="ColorThemePicker" />
    <h2>{`Scales`}</h2>
    <Note variant="warning" mdxType="Note">
  Avoid referencing scale variables directly when building UI that needs to
  adapt to different color themes. Instead, use the functional variables. In
  rare cases, you may need to use scale variables to define custom functional
  variables in your application.
    </Note>
    <ColorScales mdxType="ColorScales" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      